
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    day: { type: String, required: true },
    month: { type: String, required: true }
  }
})
